// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemCard_wrapper__Tsg7r","brand":"ItemCard_brand__PtiEt","id":"ItemCard_id__Lng1K","price":"ItemCard_price__YQv8Y","product":"ItemCard_product__4qJyv"};